<!--
 * @Author: your name
 * @Date: 2020-12-09 19:53:32
 * @LastEditTime: 2020-12-19 17:37:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /shopManagement/src/components/popover/popoverTitle.vue
-->
<template>
  <el-input
    class="my-input"
    placeholder="请输入完整工单号回车搜索"
    prefix-icon="el-icon-search"
    clearable
    @change="onSearch"
    v-model="inputValue"
  >
    <el-icon slot="prefix" type="search" :style="{ color: '#A0B0AC' }" />
  </el-input>
</template>
<script>
export default {
  name: "popoverTitle",
  props: {
    inputText: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      inputValue: this.inputText,
    };
  },
  methods: {
    /**
     * @description: 回车搜索列表
     * @param {*}
     * @return {*}
     */
    onSearch() {
      this.$emit("onSearch", this.inputValue);
    },
    /**
     * @description: 搜索框变化回调
     * @param {*}
     * @return {*}
     */
    onChange() {
      if (!this.inputValue) {
        this.$emit("onChange");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-input {
  /deep/ .el-input__inner {
    margin: 7px 0;
    background-color: #f3f7f6;
    padding: 7px 10px 7px 30px;
    border-radius: 11px;
    border-color: transparent;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basic/popover/popoverTitle.vue